<template>
  <div
    class="
      mb-7 mt-12 border-y border-gray-255 py-3 pl-2 pr-1
      lg:mt-0
    "
  >
    <button type="button" class="flex w-full items-center justify-between" @click="open = !open">
      <span class="typo-h-3">{{ $t(`taxonomy.${taxonomy}`) }}</span>
      <AnimatedIconFilter
        :active="open"
        class="
          color-red-500 mr-2 size-7 text-red-500 transition duration-150
          ease-out
        "
      />
    </button>
    <div ref="collapseRef">
      <div class="px-1 pb-2 pt-4">
        <div class="space-y-2" :class="{ 'cursor-wait': loading }">
          <Checkbox
            :model-value="filterAll"
            :disabled="loading"
            :class="{ 'pointer-events-none': filterAll || loading }"
            @click="filterAll ? $event.preventDefault() : undefined"
            @update:model-value="$emit('update:filterAll', $event.checked)"
          >
            {{ $t('filter.all') }}
          </Checkbox>
          <Checkbox
            v-for="term in terms"
            :key="term.id"
            :model-value="selectedSlugs.includes(term.slug)"
            :disabled="loading"
            :class="{ 'pointer-events-none': loading }"
            @update:model-value="$emit('update:term', term.slug, $event.checked)"
          >
            {{ term.title }}
          </Checkbox>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  breakpointsTailwind, useBreakpoints,
} from '@vueuse/core'

const breakpoints = useBreakpoints(breakpointsTailwind)
const maxLg = breakpoints.smaller('lg')

defineProps<{
  taxonomy: string
  terms: Array<{
    id: string
    title: string
    slug: string
  }>
  filterAll: boolean
  selectedSlugs: string[]
  loading?: boolean
}>()

defineEmits<{
  'update:filterAll': [checked: boolean]
  'update:term': [slug: string, checked: boolean]
}>()

const collapseRef = ref<HTMLElement | undefined>(undefined)

const options = {
  duration: 300,
  initiallyClosed: maxLg.value,
}

const open = useCollapse(collapseRef, options)

watch(maxLg, () => {
  open.value = !maxLg.value
})
</script>
